import { render, staticRenderFns } from "./MypageDetailsSettingPane.vue?vue&type=template&id=8fbe45a0&scoped=true"
import script from "./MypageDetailsSettingPane.vue?vue&type=script&lang=ts"
export * from "./MypageDetailsSettingPane.vue?vue&type=script&lang=ts"
import style0 from "./MypageDetailsSettingPane.vue?vue&type=style&index=0&id=8fbe45a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fbe45a0",
  null
  
)

export default component.exports